export default __webpack_public_path__ + "static/media/background.3ffdce50.jpg";